import { useEffect, useRef, useMemo } from 'react';
import { WandSparkles } from 'lucide-react';

interface ProgressIndicatorProps {
  progress: number;
}

const STEPS = [
  { threshold: 0, text: 'Leyendo tu pedido...' },
  { threshold: 20, text: 'Buscando productos en el catálogo...' },
  { threshold: 50, text: 'Eligiendo los más adecuados...' },
  { threshold: 80, text: 'Armando tu carrito...' },
  { threshold: 95, text: 'Casi listo...' },
];

export function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const stepText = useMemo(() => {
    for (let i = STEPS.length - 1; i >= 0; i--) {
      if (progress >= STEPS[i].threshold) return STEPS[i].text;
    }
    return STEPS[0].text;
  }, [progress]);

  return (
    <div ref={containerRef} className="bg-white rounded-lg p-8 md:p-12 shadow-sm text-center">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-green-50 mb-5">
        <WandSparkles className="w-7 h-7 text-green-600 animate-pulse" />
      </div>

      <h3 className="text-gray-800 text-lg font-bold m-0 mb-1">
        Armando tu carrito
      </h3>
      <p className="text-gray-400 text-sm m-0 mb-6">
        {stepText}
      </p>

      <div className="max-w-md mx-auto">
        <div className="bg-gray-100 rounded-full h-2.5 overflow-hidden">
          <div
            className="h-full bg-green-500 rounded-full transition-[width] duration-500 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-gray-300 text-xs m-0 mt-2">
          {Math.round(progress)}%
        </p>
      </div>
    </div>
  );
}
